module.exports = __webpack_public_path__ + "img/succu.d30b7ca6.svg";